





















































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateMeter from "./createfictitiousmeter.vue";
import EditMeter from "./editfictitiousmeter.vue";
import CopyMeter from "./copyfictitiousmeter.vue";
import Moment from "moment-timezone";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";

class PageMeterRequest extends PageRequest {
  keyword: string;
  areaId: number;
  onlyNo: number;
  modelId: number = 0;
  applicationId: number = 0;
  transferType: number = 0;
  meterType: number = 0;
  controleType: number = 0;
  isEnabel: number = 9; //nullable
}

@Component({
  components: { CreateMeter, EditMeter, CopyMeter },
})
export default class FictitiousMeter extends AbpBase {
  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  edit() {
    this.editModalShow = true;
  }
  async copy() {
    this.copyModalShow = true;
  }
  //filters
  pagerequest: PageMeterRequest = new PageMeterRequest();
  columnlist: any[] = [];
  searchName: string = ""; //树形搜索名称
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  copyModalShow: boolean = false;
  height: number = 300; //表格高度
  loadingdata: boolean = false;
  showcolumn: boolean = false; //显示列选择窗口
  splitnum: number = 0.15;
  /**
   * 改变排序
   * @param key 
   */
  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  get list() {
    return this.$store.state.fictitiousmeter.list;
  }
  get loading() {
    return this.$store.state.fictitiousmeter.loading;
  }
  create() {
    this.createModalShow = true;
  }
  showcol() {
    this.showcolumn = true;
  }
  isActiveChange(val: number) {
    this.pagerequest.isEnabel = val;
    this.$store.commit("fictitiousmeter/setCurrentPage", 1);
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.areaId = item[0].id;
    }
    this.$store.commit("fictitiousmeter/setCurrentPage", 1);
    this.getpage();
  }
  /**
   * 搜索树形结构
   * @param value 
   * @param treeList 
   */
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    const rebuildData = (value, treeList) => {
      let newarr = [];
      treeList.forEach((element) => {
        if (element.children && element.children.length) {
          if (element.title != null && element.title.indexOf(value) > -1) {
            element.expand = true;
            newarr.push(element);
          }
          const ab = rebuildData(value, element.children);
          const obj = {
            ...element,
            expand: true,
            children: ab,
          };
          if (ab && ab.length) {
            newarr.push(obj);
          }
        } else {
          if (element.title != null && element.title.indexOf(value) > -1) {
            newarr.push(element);
          }
        }
      });
      return newarr;
    };
    this.areaTree = [];
    this.areaTree = rebuildData(value, this.areaTreeList);
  }
  /**
   * 区域
   */
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  /**
   * 页改变
   * @param page 
   */
  pageChange(page: number) {
    this.$store.commit("fictitiousmeter/setCurrentPage", page);
    this.getpage();
  }
  /**
   * 每页数量改变
   * @param pagesize 
   */
  pagesizeChange(pagesize: number) {
    this.$store.commit("fictitiousmeter/setPageSize", pagesize);
    this.getpage();
  }
  /**
   * 获取数据
   */
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "fictitiousmeter/getAll",
      data: this.pagerequest,
    });
  }
  /**
   * 页码
   */
  get pageSize() {
    return this.$store.state.fictitiousmeter.pageSize;
  }
  get totalCount() {
    return this.$store.state.fictitiousmeter.totalCount;
  }
  get currentPage() {
    return this.$store.state.fictitiousmeter.currentPage;
  }
  /**
   * 列名
   */
  columns = [
    {
      type: "index",
      width: 80,
      align: "left",
      fixed: "left",
      title: this.L("IndexNo"),
      sortId: 0,
    },
    {
      sortable: true,
      title: this.L("Meter"),
      key: "meterNo",
      resizable: true,
      width: 160,
      fixed: "left",
      sortId: 2,
      tree: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.meterNo,
            },
          },
          params.row.meterNo
        );
      },
    },
    {
      title: this.L("Price"),
      key: "priceName",
      width: 130,
      sortable: true,
      sortId: 4,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.priceName,
            },
          },
          params.row.priceName
        );
      },
    },
    {
      title: this.L("Organizations"),
      key: "organizationName",
      width: 130,
      resizable: true,
      sortId: 5,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.organizationName,
            },
          },
          params.row.organizationName
        );
      },
    },
    {
      title: this.L("Areas"),
      key: "areaName",
      sortable: true,
      width: 130,
      resizable: true,
      sortId: 6,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.areaName,
            },
          },
          params.row.areaName
        );
      },
    },
    {
      sortable: true,
      title: this.L("RoomNo"),
      key: "roomNo",
      width: 130,
      resizable: true,
      sortId: 10,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.roomNo,
            },
          },
          params.row.roomNo
        );
      },
    },
    {
      sortable: true,
      title: this.L("Customer"),
      key: "customerName",
      width: 130,
      resizable: true,
      sortId: 10,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.customerName,
            },
          },
          params.row.customerName
        );
      },
    },
    {
      sortable: true,
      title: this.L("ReadNum"),
      key: "lastReadNum",
      width: 150,
      resizable: true,
      sortId: 6,
    },
    {
      title: this.L("Tip"),
      key: "TipReadNum",
      width: 130,
      resizable: true,
      sortId: 8,
    },
    {
      title: this.L("Peak"),
      key: "peakReadNum",
      width: 130,
      resizable: true,
      sortId: 8,
    },
    {
      title: this.L("Flat"),
      key: "flatReadNum",
      width: 130,
      resizable: true,
      sortId: 8,
    },
    {
      title: this.L("Valley"),
      key: "valleyReadNum",
      width: 130,
      resizable: true,
      sortId: 8,
    },
    {
      sortable: true,
      title: this.L("Reporting") + this.L("Time"),
      key: "lastReadTime",
      width: 150,
      resizable: true,
      sortId: 7,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.lastReadTime == null
            ? ""
            : Moment(params.row.lastReadTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("Location"),
      key: "location",
      width: 130,
      resizable: true,
      sortId: 17,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.location,
            },
          },
          params.row.location
        );
      },
    },
    {
      title: this.L("SortName"),
      key: "sortCode",
      width: 130,
      resizable: true,
      sortId: 47,
    },
    {
      title: this.L("Description"),
      key: "description",
      width: 130,
      sortId: 48,
      resizable: true,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.description },
            },
            params.row.description
          ),
        ]);
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 180,
      fixed: "right",
      sortId: 49,
      render: (h: any, params: any) => {
        if (params.row.children != null) {
          let del = this.checkButtonAuth('fictitiousmeterDel');
          let edit = this.checkButtonAuth('fictitiousmeterEdit');
          let copy = this.checkButtonAuth('fictitiousmeterCopy')
          return h("div", [
            copy ? h(
              "Button",
              {
                props: {
                  type: "success",
                  size: "small",
                },
                style: {
                  marginRight: "5px",
                },
                on: {
                  click: () => {
                    this.$store.commit("fictitiousmeter/edit", params.row);
                    this.copy();
                  },
                },
              },
              this.L("Copy")
            ) : '',
            edit ? h(
              "Button",
              {
                props: {
                  type: "primary",
                  size: "small",
                },
                style: {
                  marginRight: "5px",
                },
                on: {
                  click: () => {
                    this.$store.commit("fictitiousmeter/edit", params.row);
                    this.edit();
                  },
                },
              },
              this.L("Edit")
            ) : '',
            del ? h(
              "Button",
              {
                props: {
                  type: "error",
                  size: "small",
                },
                on: {
                  click: async () => {
                    this.$Modal.confirm({
                      title: this.L("Tips"),
                      content: this.L("DeleteConfirm"),
                      okText: this.L("Yes"),
                      cancelText: this.L("No"),
                      onOk: async () => {
                        await this.$store.dispatch({
                          type: "fictitiousmeter/delete",
                          data: params.row,
                        });
                        await this.getpage();
                      },
                    });
                  },
                },
              },
              this.L("Delete")
            ) : '',
          ]);
        }
      },
    },
  ];
  async created() {
    this.getAreaTree();
    this.pagerequest.isEnabel = 9;
    this.pagerequest.meterType = 133;
    this.getpage();
  }
  data() {
    return {
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));

    if (detaillist.length > 0) {
      let info = detaillist.filter((p) => {
        return p.itemId == 8;
      });
      info.forEach((ele) => {
        this.$data.applicationType.push({
          label: ele.name,
          value: ele.id,
        });
      });
      let trans = detaillist.filter((p) => {
        return p.itemId == 13;
      });
      trans.forEach((ele) => {
        this.$data.transferType.push({
          label: ele.name,
          value: ele.id,
        });
      });
      let metert = detaillist.filter((p) => {
        return p.itemId == 7;
      });
      metert.forEach((ele) => {
        this.$data.meterType.push({
          label: ele.name,
          value: ele.id,
        });
      });
      let control = detaillist.filter((p) => {
        return p.itemId == 14;
      });
      control.forEach((ele) => {
        this.$data.controleType.push({
          label: ele.name,
          value: ele.id,
        });
      });
    }
  }
  mounted() {
    if (window.innerHeight > 800) {
      this.height = window.innerHeight - 380;
    } else {
      this.height = window.innerHeight - 420;
    }
  }
}
